import { MIXPANEL_EVENT_PROPERTIES } from '../../../../shared/mixpanel';

export const FILTER_NAME_MAPPER = {
    industries: MIXPANEL_EVENT_PROPERTIES.INDUSTRY,
    keywords: MIXPANEL_EVENT_PROPERTIES.ELEMENTS,
} as const;
